export default __webpack_public_path__ + "static/media/warning.ea078e36.svg";